import { assertNumber, roundToCommonDecimals } from '@pkg/utils';

interface CommonRange {
    min?: number;
    max?: number;
}

interface ValueBounds extends CommonRange {
    allowFloat?: boolean;
}

export const STEP = {
    MIN: 0.01,
    DEFAULT: 1,
};

export function numberFromString(value = '') {
    const parsed = parseFloat(value);
    return assertNumber(parsed) ? parsed : undefined;
}

export function maxWithinBounds({ min, max }: CommonRange) {
    if (min === undefined) return undefined;
    return max !== undefined && max <= min ? min + 1 : max;
}

export function valueWithinBounds(value: number, { min, max, allowFloat }: ValueBounds) {
    const withinMinBound = Math.max(value, min ?? value);
    const withinMaxBound = Math.min(withinMinBound, max ?? withinMinBound);

    return allowFloat ? roundToCommonDecimals(withinMaxBound) : Math.floor(withinMaxBound);
}
